var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle, _path32, _path33, _path34, _path35, _path36, _path37, _polygon, _path38, _polygon2, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _circle2, _circle3, _path46, _path47, _path48, _path49, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWomenHighlight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-33 30.3 892 500.7",
    style: {
      enableBackground: "new -33 30.3 892 500.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F1F1F1;}\r\n\t.st1{fill:#CBCBCB;}\r\n\t.st2{fill:#E5E5E5;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#F56565;}\r\n\t.st5{fill:#3F3D56;}\r\n\t.st6{fill:#ECC19C;}\r\n\t.st7{fill:#FFB8B8;}\r\n\t.st8{fill:#2F2E41;}\r\n\t.st9{fill:#A0616A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b2aec908-dac2-485e-9341-1f8763a52ddc-280",
    className: "st0",
    d: "M798.6,501.8c-0.2,9-1.8,18-4.5,26.6c-0.1,0.2-0.1,0.4-0.2,0.6 h-16.7c0-0.2,0-0.4,0.1-0.6c1.1-12.8-5.3-90-13-103.4C764.9,426.1,799.9,461.1,798.6,501.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bc80851e-3fc6-46a5-adb1-be50bb758626-281",
    className: "st0",
    d: "M797.3,528.4c-0.1,0.2-0.3,0.4-0.4,0.6h-12.6 c0.1-0.2,0.2-0.4,0.3-0.6c2.1-3.7,8.2-14.9,13.9-26.6c6.1-12.5,11.8-25.4,11.3-30.1C810,472.8,814.2,505,797.3,528.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ac74e0d2-c10f-4860-b119-67c8c5820ae0-282",
    className: "st0",
    d: "M13.4,508.8c0.2,6.7,1.3,13.3,3.3,19.7c0,0.1,0.1,0.3,0.1,0.4 h12.4c0-0.1,0-0.3,0-0.4c-0.8-9.5,3.9-66.9,9.6-76.8C38.4,452.6,12.4,478.5,13.4,508.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "b887613c-750d-48e2-8424-1e5e637b4506-283",
    className: "st0",
    d: "M14.3,528.6c0.1,0.1,0.2,0.3,0.3,0.4h9.3 c-0.1-0.1-0.2-0.3-0.2-0.4c-1.5-2.8-6.1-11.1-10.3-19.7c-4.5-9.3-8.7-18.9-8.4-22.4C4.9,487.3,1.7,511.2,14.3,528.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621,381.5c-93.9-39.8-178.9-38.3-259-14c-123.4-21.5-207.8-18.2-262,14v-100h521V381.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M621,354c-86.6-39.2-173-41.7-260.8,0c-89.9-25.9-176.8-25.6-260.8,0V50c89.3-26.7,176.2-26,260.8,0 c89.4-25.9,176.4-26.7,260.8,0V354z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123,87.7l-2.9-7.5c1.1-0.4,28.4-11,68.4-16.4c37-5,92.1-6.2,144.6,16.4l-3.2,7.3 C279.2,65.9,225.7,67,189.8,71.8C150.7,77,123.3,87.6,123,87.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123,115.7l-2.9-7.5c1.1-0.4,28.4-11,68.4-16.4c37-5,92.1-6.2,144.6,16.4l-3.2,7.3 C279.2,93.9,225.7,95,189.8,99.8C150.7,105,123.3,115.6,123,115.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123,143.7l-2.9-7.5c1.1-0.4,28.4-11,68.4-16.4c37-5,92.1-6.2,144.6,16.4l-3.2,7.3 c-50.7-21.8-104.2-20.7-140.2-15.9C150.7,133,123.3,143.6,123,143.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123,171.7l-2.9-7.5c1.1-0.4,28.4-11,68.4-16.4c37-5,92.1-6.2,144.6,16.4l-3.2,7.3 c-50.7-21.8-104.2-20.7-140.2-15.9C150.7,161,123.3,171.6,123,171.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123,199.7l-2.9-7.5c1.1-0.4,28.4-11,68.4-16.4c37-5,92.1-6.2,144.6,16.4l-3.2,7.3 c-50.7-21.8-104.2-20.7-140.2-15.9C150.7,189,123.3,199.6,123,199.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123,227.7l-2.9-7.5c1.1-0.4,28.4-11,68.4-16.4c37-5,92.1-6.2,144.6,16.4l-3.2,7.3 c-50.7-21.8-104.2-20.7-140.2-15.9C150.7,217,123.3,227.6,123,227.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M384,286.7l-2.9-7.5c1.1-0.4,28.4-11,68.4-16.4c37-5,92.1-6.2,144.6,16.4l-3.2,7.3 c-50.7-21.8-104.2-20.7-140.2-15.9C411.7,276,384.3,286.6,384,286.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M381.5,233V80.1l2.8-0.9c71.1-22.2,141.9-22.2,210.4,0l2.8,0.9v152.7l-5.4-2c-71.3-26.9-140.3-26.9-205.1,0 L381.5,233z M487.1,202.5c33.5,0,67.6,6.2,102.4,18.7V85.9c-65.1-20.5-132.4-20.5-200,0v135.1C420.6,208.8,453.7,202.5,487.1,202.5z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M589.7,282.8l1-25.5l35.9-71.5c1-2,2.7-3.7,4.7-4.7c2.5-1.3,5.4-1.4,8.1-0.5c3.1,1.1,5.5,3.5,6.5,6.6 c0.2,0.7,0.4,1.3,0.5,2c0.3,2.1-0.1,4.1-1,6l-36,71.6L589.7,282.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M635.9,180.6l-39,77.6l-3-1.5l37.7-75C633,181,634.4,180.6,635.9,180.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M646,189.4L608.5,264l-3-1.5l38.9-77.4c0.5,0.7,0.9,1.5,1.1,2.4C645.8,188.1,645.9,188.7,646,189.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M642.3,182.7l-39.5,78.4l-3-1.5l39.5-78.5c0.4,0.1,0.8,0.3,1.2,0.5C641.2,181.9,641.7,182.3,642.3,182.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M594.2,278.5l-4,3.2l0.3-8.4C592,273.7,593.4,275.8,594.2,278.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202.7,370.4l-4.8-14.4l5.1-47.4c0.1-1.3,0.7-2.6,1.6-3.6c1.1-1.2,2.7-1.9,4.4-2c2-0.1,3.8,0.8,5,2.3 c0.3,0.3,0.5,0.7,0.7,1c0.6,1.1,0.8,2.3,0.7,3.6l-5.1,47.5L202.7,370.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207,303.7l-5.5,51.5l-2-0.2l5.3-49.8C205.4,304.5,206.2,304,207,303.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M214.5,306.5l-5.3,49.5l-2-0.2l5.5-51.3c0.4,0.3,0.8,0.7,1.1,1.1C214.1,305.8,214.3,306.1,214.5,306.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M211,303.5l-5.6,52l-2-0.2l5.6-52.1c0.3,0,0.5,0,0.8,0C210.2,303.3,210.6,303.4,211,303.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.3,367l-1.5,2.6l-1.6-4.8C202,364.8,203.3,365.7,204.3,367z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "bb56e1bb-a377-463a-b777-e3f2ac15f40f-284",
    className: "st6",
    d: "M717.4,353.4c-2.3,4-7.3,5.4-11.3,3.1c-4-2.3-5.4-7.3-3.1-11.3 c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0.2-0.4,0.5-0.8,0.8-1.1l-7-49.8l-0.2-1.5l-1.4-10.2l-0.2-1.5l0.8,0l13.5,0.6l3.6,0.2l0.5,9.3 l2.6,52.1C718.8,345.9,719.4,350.1,717.4,353.4L717.4,353.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "a248d591-cba6-4901-9d10-c9b24d625163-285",
    className: "st1",
    d: "M696.7,293.2l17.2-1.6c1.9-0.2,3.2-1.8,3.1-3.7l-3.2-35.7 c-0.6-7.2-7-12.5-14.1-11.8c-7.2,0.6-12.5,7-11.8,14.1c0,0.2,0.1,0.5,0.1,0.7l5.2,35.1c0.2,1.7,1.7,2.9,3.3,2.9 C696.5,293.2,696.6,293.2,696.7,293.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "f743e301-5bba-4392-b658-4efdfb4065cc-286",
    className: "st1",
    d: "M709.7,264.3c3.6-10.1,0-21.4-8.8-27.6 c-6.5-4.4-15.4-6-24.9,5.3c-11.6,13.9-19.8,30.2-24.1,47.8l39.1,6.4C691,296.2,704.3,279.9,709.7,264.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "eac80286-6d9c-481f-b372-04b3b845d333-287",
    className: "st7",
    d: "M646.5,520.5h-11.2l-5.3-43h16.5L646.5,520.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "e474a022-de70-4f17-bf9b-ca694d09b1b4-288",
    className: "st8",
    d: "M613.8,530.8h35.1v-13.5h-21.5 C619.9,517.3,613.8,523.3,613.8,530.8L613.8,530.8L613.8,530.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "a9ae19c7-51aa-4dd0-9022-ef91b49440e0-289",
    className: "st7",
    d: "M738.2,510.7l-10.6,3.5L709,475.1l15.6-5.2L738.2,510.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "bdf88be3-aecd-443e-97f8-a32ede953949-290",
    className: "st8",
    d: "M710.4,530.8l33.3-11l-4.3-12.9l-20.4,6.7 C711.9,516,708,523.7,710.4,530.8L710.4,530.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "e601451a-496c-4b1c-9fe2-c3a71e9d5111",
    className: "st6",
    cx: 685.2,
    cy: 203.1,
    r: 22.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "fd5880a1-dddd-4cd5-886d-5f97a9f21c4e-291",
    className: "st8",
    d: "M665.6,508.5l10.4-68.4c0.3-1.7,1.9-2.9,3.6-2.7 c1.3,0.2,2.3,1.1,2.6,2.4L698,505c0.5,2.1,2.5,3.4,4.6,3.1l43.5-7c2.2-0.4,3.8-2.5,3.4-4.7c0-0.2-0.1-0.4-0.1-0.5l-56.7-187 c-0.2-0.5-0.2-1.1-0.1-1.6l1.9-8.2c0.4-1.8-0.4-3.7-2.1-4.6c-7.7-3.9-27.3-12.1-42.1-3.2c-1,0.6-1.7,1.6-1.9,2.7l-44.3,208.3 c-0.5,2.2,0.9,4.4,3.2,4.9c0.2,0,0.3,0.1,0.5,0.1l53.4,4.8c0.1,0,0.2,0,0.4,0C663.6,512,665.3,510.5,665.6,508.5L665.6,508.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "acdc6559-e36c-4b0b-aac1-c1a10856fa7d-292",
    className: "st8",
    d: "M700,187.3c-1.7-1-3.2-2.3-4.4-3.8c-1.2-1.6-1.6-3.7-0.9-5.5 c1.1-2.5,4.5-3.3,7.1-2.4s4.6,2.9,6.5,4.9c1.7,1.7,3.4,3.5,4.2,5.8s0.4,5.2-1.6,6.5c-1.9,1.4-4.7,0.8-6.6-0.7 c-1.8-1.6-3.2-3.5-4.1-5.7L700,187.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "a8902353-3630-4aaa-9386-a524a4077d2f-293",
    className: "st8",
    d: "M707.6,181c0.1-6.3,7.3-10.8,13.5-9.7s11,6.4,13.3,12.2 c5,12.3,1.3,26.4-3.6,38.8s-10.9,25-10.2,38.2c1,14.6,9.9,27.5,23.2,33.7c-7,3.2-15.4-0.1-21.2-5c-13.1-11-18.1-30.5-12-46.4 c3-7.9,8.3-14.6,12.5-21.9s7.2-15.9,5.1-24.1s-11.3-14.7-19.1-11.6L707.6,181z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "b05157c8-b93b-43b3-a4ba-0cfdfe0a562e-294",
    className: "st8",
    d: "M683.8,213c1.9-3.3,3.9-7.6,0.4-10.5c-1.6-1.2-3.5-1.7-5.5-1.5 c-4,0.5-8.4,0.7-12.3-0.8c-2.9-1-5.4-3.2-6.7-6c-2-4.8,0.5-10.5,4.7-13.5c5.2-3.6,12.1-3.7,17.5-0.3c5.4-2.4,12-1.3,17,2 s8.3,8.6,10.1,14.2c1.7,4.9,2,10.1,0.8,15.1c-1.9,7.1-7.1,12.8-13.9,15.4c-2.7,1.1-5.7,0.6-8-1.2c-1.8-1.6-3.2-3.7-4-5.9 C683.2,217.5,682.8,214.8,683.8,213z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "fb245157-e4e6-4551-ad6a-dca5f4b0f94b-295",
    className: "st6",
    d: "M617.6,233c0.1,0.5,0.2,1,0.2,1.5l39.1,22.5l9.5-5.5l10.1,13.3 l-15.9,11.3c-2.6,1.9-6.2,1.8-8.7-0.2l-40.3-31.8c-4.9,1.8-10.4-0.7-12.3-5.6s0.7-10.4,5.6-12.3c4.9-1.8,10.4,0.7,12.3,5.6 C617.3,232.2,617.5,232.6,617.6,233L617.6,233z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "b7c0657c-f78e-4619-b8ae-65b0c7791644-296",
    className: "st1",
    d: "M658.2,258.1l12.6,16.4c1.4,1.8,4,2.1,5.7,0.7 c0.2-0.1,0.3-0.3,0.4-0.4l14.3-14.8c5-3.7,6.1-10.9,2.4-15.9s-10.9-6.1-15.9-2.4c0,0,0,0-0.1,0c-0.1,0.1-0.2,0.2-0.4,0.3l-17.9,10 c-2,1.1-2.7,3.6-1.6,5.6C657.9,257.7,658,257.9,658.2,258.1L658.2,258.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "175.6,519.1 187.7,519.1 193.4,472.3 175.6,472.3 "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M172.5,515.1l23.9,0h0c8.4,0,15.2,6.8,15.2,15.2v0.5l-39.1,0L172.5,515.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "81.2,513.8 93.1,515.6 105.8,470.2 90.1,467.6 "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M78.7,509.4l23.6,3.6l0,0c8.3,1.3,14,9,12.8,17.3l-0.1,0.5L76.3,525L78.7,509.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M118.5,287.3l13.5,3.5l-0.9,21.8l-0.1,39.7c3.6,2.5,4.5,7.5,2,11.1c-2.5,3.6-7.5,4.5-11.1,2s-4.5-7.5-2-11.1 c0.2-0.2,0.3-0.5,0.5-0.7l-4.1-39.9L118.5,287.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.2,262.3c0.2-4.3,2.8-8.1,6.8-9.8c3.7-1.7,8.1-1,11.1,1.8c2.2,1.9,3.3,4.7,3.3,7.6 c0,12.8-2.9,31.4-2.9,31.6l0,0.3l-19.7,6.6L116.2,262.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.4,298.6l30.1-7.8l13.9,46.9l0.5,174.5l-23-0.1l-9.6-141.3l-61.3,130.5l-24.7-3l53.9-139.9 c0,0-3-24.7,6.4-37.1l-2-12.9L151.4,298.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.1,310.3c-0.9-1-1.2-2.4-1-3.7l-13.7-41.2c-1.3-3.9-0.2-8.3,2.9-11.1l6-5.4l4-16.2l23.2,5.7l-1.9,7.6 l10.5-1.9l22.1,49.3l-46.2,18.5l-2.3,0C133.3,312,132,311.3,131.1,310.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M163.3,275.5l13.3-4.2l10.9,18.9l21.1,33.6c4.4,0.2,7.8,3.9,7.6,8.3c-0.2,4.4-3.9,7.8-8.3,7.6 c-4.4-0.2-7.8-3.9-7.6-8.3c0-0.3,0-0.6,0.1-0.9l-24.8-31.5L163.3,275.5z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148,255.6c-2.2-3.7-2-8.4,0.5-11.9c2.3-3.4,6.3-5.1,10.4-4.4c2.8,0.5,5.3,2.2,6.8,4.7 c6.9,10.8,14.4,28.1,14.5,28.3l0.1,0.3l-13.1,16.1L148,255.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 146.4,
    cy: 211.3,
    r: 18.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 113.8,
    cy: 185.8,
    r: 17.8
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.5,200.5c8,5.7,19.1,4,24.8-4c1.2-1.6,2.1-3.4,2.6-5.3c-1.2,9.7-10.1,16.6-19.8,15.4s-16.6-10.1-15.4-19.8 c0.1-1,0.3-1.9,0.6-2.9C90.5,190.3,93.3,196.7,98.5,200.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M168.6,200.5c-3.1-5.6-4.3-7.9-8.3-11.2c-3.5-3-7.9-3.9-11.4-1c-10.7-4.6-23,0.3-27.6,11 c-4.6,10.7,0.3,23,11,27.6c10.7,4.6,23-0.3,27.6-11c1.1-2.6,1.7-5.5,1.7-8.3c0-0.8-0.1-1.6-0.1-2.4 C164.5,204.7,165.6,200.9,168.6,200.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349,531H-32c-0.6,0-1-0.4-1-1s0.4-1,1-1h381c0.6,0,1,0.4,1,1S349.6,531,349,531z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M858,531H477c-0.6,0-1-0.4-1-1s0.4-1,1-1h381c0.6,0,1,0.4,1,1S858.6,531,858,531z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 359.3,
    y: 50,
    className: "st1",
    width: 2,
    height: 303
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomenHighlight);
export default __webpack_public_path__ + "static/media/women_highlight.e3d27e0cf20e20669c8ef8377d70b8f3.svg";
export { ForwardRef as ReactComponent };